import { Edit, Remove, View } from "@app/components/Actions";
import pathRoutes from "../../../routes/pathRoutes";
import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useCalibrationUncertainty } from "@services/servicesGenericsTables";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const padId = (id: number, length: number) => {
  return id.toString().padStart(length, "0");
};

export const columnsUncertainty: GridColDef[] = [
  {
    field: "id",
    headerName: "ID incertidumbre",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => (
      <div className="flexCenter">I{padId(params.row.id, 4)}</div>
    ),
  },
  {
    field: "tipo_incertidumbre.nombre",
    headerName: "Tipo incertidumbre",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => <div className="flexCenter">{params.value}</div>,
    valueGetter: (params) => params.row.tipo_incertidumbre?.nombre,
  },
  {
    field: "date",
    headerName: "Fecha Alta",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => (
      <div className="flexCenter">
        {dayjs(params.row.date).format("DD/MM/YYYY")}
      </div>
    ),
  },
  {
    field: "actions",
    headerName: "Acciones",
    width: 150,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => (
      <>
        <View to={`${pathRoutes.ADMIN_INCERTIDUMBRES}/ver/${params.id}`} />
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Edit to={`${pathRoutes.ADMIN_INCERTIDUMBRES}/editar/${params.id}`} />
          <Remove
            onRemove={() =>
              useCalibrationUncertainty.getState().remove(params.row.id)
            }
          />
        </PermissionComponentGate>
      </>
    ),
  },
];
